/** Rebrand Colors */
export const EGYPTIAN_BLUE_100 = '#2847C6';
// export const EGYPTIAN_BLUE_90 = "#3E59CC";
// export const EGYPTIAN_BLUE_50 = "#94A3E3";
export const EGYPTIAN_BLUE_30 = '#BFC8EE';
// export const EGYPTIAN_BLUE_20 = "#D4DAF4";
// export const EGYPTIAN_BLUE_10 = "#EAEDF9";

// export const ANCIENT_BLUE_20 = "#DCE7F9";
// export const ANCIENT_BLUE_30 = "#CADCF6";
// export const ANCIENT_BLUE_50 = "#A7C4F0";

// export const CARRIBEAN_GREEN_100 = "#008E9B";
// export const CARRIBEAN_GREEN_50 = "#80CFD6";
// export const CARRIBEAN_GREEN_30 = "#B3E2E6";

// export const BLUE_10 = "#EAFAFC";
// export const BLUE_20 = "#D5F5F9";
// export const BLUE_30 = "#C0F0F7";
// export const BLUE_40 = "#ABEBF4";
// export const BLUE_50 = "#96E6F1";
// export const BLUE_80 = "#56D7E9";
// export const BLUE_90 = "#41D2E6";
// export const BLUE_100 = "#2CCDE3";
// export const BLUE_110 = "#28B9CC";
// export const BLUE_OCEAN_900 = "#02406A";

// export const YELLOW_GOLDEN_500 = "#E9B631";

export const PURPLE_700 = '#6639B7';

// export const PHAROAHS_GEM_20 = "#CCF3F0";
// export const PHAROAHS_GEM_30 = "#B3EDE9";
// export const PHAROAHS_GEM_50 = "#80E2DB";
// export const PHAROAHS_GEM_80 = "#33D0C5";
// export const PHAROAHS_GEM_100 = "#00C4B6";
// export const PHAROAHS_GEM_110 = "#00B0A4";

// export const SPHYNX_PINK_20 = "#FEEDF0";
// export const SPHYNX_PINK_30 = "#FDE4E8";
// export const SPHYNX_PINK_100 = "#F9A5B2";
// export const SPHYNX_PINK_110 = "#E095A0";

// export const AMETHYST_50 = "#E0C0E8";
// export const AMETHYST_100 = "#C181D0";

// export const SEMANTIC_ERROR_RED = "#E32C4B";
// export const SEMANTIC_PENDING_ORANGE = "#FAB839";
// export const DISABLED_RED = "#E39095";
// export const TALENT_TINT = "#F3816C";
// export const TALENT_TINT_30 = "#FBD9D3";
// export const APPROVE_GREEN = "#16CC8B";
// export const CHECK_GREEN = "#5B9F51";

// export const GREY_SCALE_05 = "#F7F7F7";
// export const GREY_SCALE_08 = "#F8F8FA";
// export const GREY_SCALE_10 = "#E8E8E8";
// export const GREY_SCALE_20 = "#D1D1D1";
// export const GREY_SCALE_30 = "#BABABA";
// export const GREY_SCALE_40 = "#A3A3A3";
// export const GREY_SCALE_60 = "#747474";
// export const GREY_SCALE_50 = "#8C8C8C";
// export const GREY_SCALE_100 = "#181818";
// export const GREY_600 = "#5F5F5F";

// /** Rebrand Colors */

// export const BLACK = "#000000";
// export const GRAY = "rgba(0,0,0,0.7)";
// export const GRAY_SHADOW = "rgba(0, 0, 0, 0.15)";
// export const GRAY_TEXT = "#A0ABC0";
// export const MEDIUM_LIGHT_GRAY = "rgba(220,220,220,0.8)";
// export const LIGHT_GRAY = "rgba(230,230,230,0.5)";
// export const LIGHT_GREY_FULL_ALPHA = "rgba(230,230,230,1)";
// export const LIGHTER_GRAY = "rgba(230,230,230,0.1)";
// export const LIGHTER_GRAY_SOLID = "rgba(245,245,245, 1)";
// export const LIGHTEST_GRAY_SOLID = "rgba(250,250,250, 1)";

// export const WHITE = "#ffffff";
export const WHITE_TRANSPARENT = "rgba(255,255,255,0.1)";
// export const WHITE_HALF_TRANSPARENT = "rgba(255,255,255,0.5)";

// // Theme colours
// export const PRIMARY = BLACK;
// export const SECONDARY = WHITE;
// export const TERTIARY = PHAROAHS_GEM_110;
// export const PRIMARY_BACKGROUND = GREY_SCALE_08;
// export const SECONDARY_BACKGROUND = BLUE_100;
// export const BORDER_COLOR = BLUE_20;
// export const STATUS_BAR = "#FFF";
// export const SIGN_IN_BACKGROUND = "#1B3349";

// // Text colours
// export const PRIMARY_TEXT = GREY_SCALE_100;
// export const PRIMARY_INPUT_BACKGROUND = "#f1f1f1";
// export const SECONDARY_TEXT = "#898989";
// export const SUCCESS = "#3d70c4";
// export const PLACEHOLDER_TEXT = "#ACACAC";
// export const ERROR_TEXT = "#BD455E";

// // Button colours
// export const PRIMARY_BUTTON = EGYPTIAN_BLUE_100;
// export const PRIMARY_BUTTON_TEXT = "#FFFFFF";
// export const SECONDARY_BUTTON = "#E5E6E6";
// export const BLUE_BUTTON_BG = EGYPTIAN_BLUE_100;

// export const ALERT_ERROR = "#BD455E";
// export const ALERT_ERROR_BACKGROUND = "#FFE8E8";
// export const ALERT_WARNING = PHAROAHS_GEM_110;
// export const ALERT_INFO = "#FFFFFF";

// export const LOADING_COLOR = PRIMARY;

// // Project specific colours

// export const NORMAL_TEXT = "#4D4646";
// export const TITLE_TEXT = "#000000";
// export const HEADING_PRIMARY = "#2b4366";
// export const HEADING_SECONDARY = "#3d70c4";
// export const HEADING_TERTIARY = "#2b4366";
// export const RATING_COLOR = "#BD455E";
// export const PRIMARY_PURPLE = EGYPTIAN_BLUE_100;
// export const PRIMARY_BLUE = "#2C4366";
// export const SECONDARY_BLUE = "#465E81";
// export const LIGHT_DESCRIPTION_TEXT = "#797979";

// export const SECONDARY_BUTTON_TEXT = "#000000";
// export const SECONDARY_BUTTON_BORDER = "#000000";

// export const CANCEL_BUTTON = "#BD455E";
// export const CANCEL_BUTTON_TEXT = "#BD455E";

// export const ACCENT_COLOR = "#13344B";
// export const DARK_BLUE_COLOR = "#30486F";
// export const LIGHT_BLUE_COLOR = "#77E1FF";
// export const DIVIDER_COLOR = "#EAEAEA";

// export const AQUA = "#90e0ff";
// export const NOTIFICATION_ALERT = "#BD455E";
// export const POSITIVE_LIME_GREEN = "#13DB6E";
// export const UNSELECTED_COLOR = "#2A5A7D";

// export const STARTER = "rgba(76, 93, 192, 0.2)";
// export const SILVER = "#D5D5D5";
// export const SILVER_BACKGROUND = "rgba(213, 213, 213, 0.5)";
// export const GOLD = "#DFBA6E";
// export const GOLD_BACKGROUND = "rgba(223, 186, 110, 0.5)";
// export const PLATINUM = "#DEDEDE";
// export const PLATINUM_BACKGROUND = "rgba(222, 222, 222, 0.5)";

// export const MEDIUM_GRAY = "rgb(230,230,230)";
// export const DARKER_MEDIUM_GRAY = "rgb(120,120,120)";

// export const EDUCATOR_PROGRESSIVE_BAR_BG = "#495AB3";
// export const EDUCATOR_PROGRESSIVE_BLUE_BG = "#c9dbf9";
// export const EDUCATOR_PROGRESSIVE_PINK_BG = "#d9d3e9";
// export const FACEBOOK_BLUE = "#1877f2";

// export const DECLINE_RED = "#F84800";
// export const ALERT_RED = "#CF183A";
// export const LIGHT_DIVIDER = "#2B5979";

// /** Lots of greys, to avoid confusion https://colornames.org was used to pick names */
// export const BLAND_GRAY = "#EEEFEF";
// export const SUGAR_GRAY = "#E9E9E9";
// export const DADA_GRAY = "#DADADA";
// export const FATE_GRAY = "#f8f8f8";
// export const WHITE_SMOKE = "#F5F5F5";
// export const FOGGY_MOUNTAIN = "#D9D9D9";
// export const VAPOR_CHROME_SPECIAL = "#DFECF9";

// export const DULL_BLUE = "#94A8C6";
// export const POWDER_BLUE = "#C8ECFA";
// export const PRESSED_METAL_BLUE = "#94A8C6";
// export const STORE_BOUGHT_SKY_BLUE = "#D6EFF9";
// export const ORANGE = "#D47202";
// export const BLUE_SOAPSUDS = "#6C768A";
// export const NAVAL_LAGOON = "#142133";

/** New Colors */
// export const CHINESE_BELLFLOWER_BLUE = "#525CB3"; // TakeAction SuperHeader
// export const ACTIVE_PURPLE = "#4F5CB9";
// export const PENDING_ORANGE = "#E89F32";

/** For Insta Agency */

/** For Insta Agency white labelling, need to migrate to theme*/
// export const ICON_BADGE_BACKGROUND = "#EBF7FC";
// export const LINK_BLUE = "#0096D7";
// export const LINK_BLUE_15 = "#EBF7FC";
// export const TEXT_LABEL_DARK = "#797979";

// White label only takes action color and secondary brand color from theme as variants
// The rest of the colors are the same for all white labels

export const ERROR_RED_15 = '#F7DEDF';
export const ERROR_RED_50 = '#E59C9F';
export const ERROR_RED_100 = '#C6222B';
export const DISABLED_RED = '#E39095';

export const WARNING_YELLOW_15 = '#FCF4E0';
export const WARNING_YELLOW_70 = '#E9B631';
export const WARNING_YELLOW_100 = '#E0870B';
export const SCDY_BASE = '#FFBC56';

export const SUCCESS_GREEN_15 = '#E6F1E5';
export const SUCCESS_GREEN_100 = '#5B9F51';

export const LINK_BLUE = '#0096D7';
export const LINK_BLUE_15 = '#EBF7FC';
export const BLACK = '#101010';
export const WHITE = '#FFFFFF';

// SUBTLE_TEXT is Grey Base
export const SUBTLE_TEXT = '#ADADAD';
export const GREY_08 = 'rgba(173, 173, 173, 0.12)';

export const GREY_BASE = SUBTLE_TEXT;
export const GREY_00 = WHITE;
export const GREY_10 = '#F0F0F0';
export const GREY_20 = '#E6E6E6';
export const GREY_30 = '#DADADA';
export const GREY_40 = '#CECECE';
export const GREY_50 = '#C1C1C1';
export const GREY_60 = '#979797';
export const GREY_70 = '#797979';
export const GREY_80 = '#5B5B5B';
export const GREY_90 = '#3C3C3C';
export const GREY_100 = '#242424';
export const LABEL_DARK = GREY_70;
export const MOBILE_BACKGROUND_COLOR = '#F8F8FA';
